document.querySelectorAll( '.b-chart-info' ).forEach( ( block ) => {

	const segmentsNodes = Array.from( block.querySelectorAll( '.js-chart-info-segment' ) );
	const layout = block.querySelector( '.b-chart-info__layout' );
	const wheelColumn = block.querySelector( '.b-chart-info__wheel-column' );
	const ring = block.querySelector( '.js-chart-info-ring' );
	const wheel = block.querySelector( '.js-chart-info-wheel' );
	const hotspotsContainer = block.querySelector( '.js-chart-info-hotspots' );
	const centerText = block.querySelector( '.b-chart-info__center-text' );
	const modal = block.querySelector( '.js-chart-info-modal' );
	const modalHeader = block.querySelector( '.b-chart-info__modal-header' );
	const modalMain = block.querySelector( '.b-chart-info__modal-main' );
	const closeButton = block.querySelector( '.js-chart-info-close' );
	const modalTitle = block.querySelector( '.js-chart-info-modal-title' );
	const modalIcon = block.querySelector( '.js-chart-info-modal-icon' );
	const modalIconWrap = block.querySelector( '.b-chart-info__modal-icon-wrap' );
	const accordion = block.querySelector( '.js-chart-info-accordion' );

	if ( ! layout || ! wheelColumn || ! ring || ! wheel || ! hotspotsContainer || ! centerText || ! modal || ! modalHeader || ! modalMain || ! closeButton || ! modalTitle || ! modalIcon || ! modalIconWrap || ! accordion || ! segmentsNodes.length ) {

		return;

	}

	let modalSummary = block.querySelector( '.js-chart-info-modal-summary' );
	const mobileViewport = window.matchMedia( '(max-width: 1023.98px)' );

	const modalTitleWrap = modalMain.querySelector( '.b-chart-info__modal-title-wrap' ) || ( () => {

		const titleWrap = document.createElement( 'span' );
		titleWrap.className = 'b-chart-info__modal-title-wrap';
		modalMain.appendChild( titleWrap );
		return titleWrap;

	} )();

	if ( modalTitle.parentNode !== modalTitleWrap ) {

		modalTitleWrap.appendChild( modalTitle );

	}

	if ( ! modalSummary ) {

		modalSummary = document.createElement( 'span' );
		modalSummary.className = 'b-chart-info__modal-description js-chart-info-modal-summary';
		modalSummary.hidden = true;
		modalTitleWrap.appendChild( modalSummary );

	} else if ( modalSummary.parentNode !== modalTitleWrap ) {

		modalSummary.classList.add( 'b-chart-info__modal-description' );
		modalTitleWrap.appendChild( modalSummary );

	}

	let activeSegmentIndex = null;
	let mobileModalsContainer = block.querySelector( '.js-chart-info-mobile-modals' );
	const centerContent = block.querySelector( '.b-chart-info__center-content' );

	/**
	 * Resolve center-hole diameter used for ring rendering and hit testing.
	 *
	 * @return {number} Hole size in px.
	 */
	const getCenterHoleSize = () => {

		const centerContentSize = centerContent?.getBoundingClientRect().width || 0;

		if ( centerContentSize > 0 ) {

			return centerContentSize;

		}

		return centerText.getBoundingClientRect().width;

	};

	let summaryContainer = block.querySelector( '.js-chart-info-summary' );

	if ( ! summaryContainer ) {

		const segmentsData = block.querySelector( '.b-chart-info__segments-data' );
		summaryContainer = document.createElement( 'div' );
		summaryContainer.className = 'b-chart-info__summary js-chart-info-summary';

		if ( segmentsData && segmentsData.parentNode === block ) {

			block.insertBefore( summaryContainer, segmentsData );

		} else {

			block.appendChild( summaryContainer );

		}

	}

	const segments = segmentsNodes.map( ( segmentNode ) => {

		const percentText = segmentNode.querySelector( '.b-chart-info-segment__percent' )?.textContent || '0';
		const percentValue = Number.parseFloat( percentText );
		const percentage = Number.isFinite( percentValue ) && percentValue > 0 ? percentValue : 0;
		const name = segmentNode.querySelector( '.b-chart-info-segment__name' )?.textContent?.trim() || '';
		const color = segmentNode.querySelector( '.b-chart-info-segment__color' )?.textContent?.trim() || '#15D19B';
		const iconElement = segmentNode.querySelector( '.b-chart-info-segment__icon' );
		const itemsNode = segmentNode.querySelector( '.b-chart-info-segment__items' );
		const summaryNode = segmentNode.querySelector( '.b-chart-info-segment__summary' );
		const modalDescriptionNode = segmentNode.querySelector( '.b-chart-info-segment__modal-description' );

		return {
			name,
			color,
			percentage,
			iconUrl: iconElement?.getAttribute( 'src' ) || '',
			iconAlt: iconElement?.getAttribute( 'alt' ) || '',
			itemsMarkup: itemsNode ? itemsNode.innerHTML : '',
			summary: summaryNode?.textContent?.trim() || '',
			modalDescription: modalDescriptionNode?.textContent?.trim() || summaryNode?.textContent?.trim() || '',
		};

	} );

	const sum = segments.reduce( ( total, segment ) => total + segment.percentage, 0 );
	const normalizedSegments = sum > 0
		? segments.map( ( segment ) => ( {
			...segment,
			percentage: ( segment.percentage / sum ) * 100,
		} ) )
		: segments.map( ( segment ) => ( {
			...segment,
			percentage: 100 / segments.length,
		} ) );

	/**
	 * Check whether mobile layout is active.
	 *
	 * @return {boolean} True when viewport is mobile.
	 */
	const isMobileLayout = () => mobileViewport.matches;

	const fallbackColorRgb = { r: 21, g: 209, b: 155 };
	const colorRgbCache = new Map();
	const cssFilterCache = new Map();

	/**
	 * Normalize color source from block attributes to a valid CSS color token.
	 *
	 * @param {string} color Raw color value.
	 * @return {string} CSS color token.
	 */
	const normalizeColorToken = ( color ) => {

		const safeColor = String( color || '' ).trim();

		if ( safeColor.startsWith( 'var:preset|color|' ) ) {

			const slug = safeColor.split( '|' ).pop();

			if ( slug ) {

				return `var(--wp--preset--color--${slug})`;

			}

		}

		if ( safeColor.startsWith( 'color-' ) ) {

			return `var(--wp--preset--color--${safeColor.replace( /^color-/, '' )})`;

		}

		return safeColor;

	};

	/**
	 * Parse CSS rgb()/rgba() string into channels.
	 *
	 * @param {string} value CSS color string.
	 * @return {?{r:number,g:number,b:number}} RGB object.
	 */
	const parseRgbColor = ( value ) => {

		const rgbMatch = value.match( /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i );

		if ( ! rgbMatch ) {

			return null;

		}

		return {
			r: Number.parseFloat( rgbMatch[ 1 ] ),
			g: Number.parseFloat( rgbMatch[ 2 ] ),
			b: Number.parseFloat( rgbMatch[ 3 ] ),
		};

	};

	/**
	 * Resolve any supported color token to RGB channels.
	 *
	 * @param {string} color Raw color value.
	 * @return {{r:number,g:number,b:number}} RGB object.
	 */
	const resolveColorToRgb = ( color ) => {

		const normalizedColor = normalizeColorToken( color );
		const cacheKey = normalizedColor || '__fallback__';
		const cached = colorRgbCache.get( cacheKey );

		if ( cached ) {

			return cached;

		}

		const hexMatch = normalizedColor.match( /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i );

		if ( hexMatch ) {

			const hex = hexMatch[ 1 ].length === 3
				? hexMatch[ 1 ].split( '' ).map( ( char ) => `${char}${char}` ).join( '' )
				: hexMatch[ 1 ];
			const resolved = {
				r: Number.parseInt( hex.slice( 0, 2 ), 16 ),
				g: Number.parseInt( hex.slice( 2, 4 ), 16 ),
				b: Number.parseInt( hex.slice( 4, 6 ), 16 ),
			};

			colorRgbCache.set( cacheKey, resolved );
			return resolved;

		}

		const parsedRgb = parseRgbColor( normalizedColor );

		if ( parsedRgb ) {

			colorRgbCache.set( cacheKey, parsedRgb );
			return parsedRgb;

		}

		const parserProbe = document.createElement( 'span' );
		parserProbe.style.color = normalizedColor;
		parserProbe.style.display = 'none';
		document.body.appendChild( parserProbe );
		const computedColor = window.getComputedStyle( parserProbe ).color;
		parserProbe.remove();

		const computedRgb = parseRgbColor( computedColor ) || fallbackColorRgb;
		colorRgbCache.set( cacheKey, computedRgb );

		return computedRgb;

	};

	/**
	 * Convert color value into rgba().
	 *
	 * @param {string} color Color value.
	 * @param {number} alpha Alpha channel value.
	 * @return {string} RGBA color.
	 */
	const hexToRgba = ( color, alpha ) => {

		const { r, g, b } = resolveColorToRgb( color );
		return `rgba(${r}, ${g}, ${b}, ${alpha})`;

	};

	/**
	 * Mutable color model used by CSS filter solver.
	 */
	class SolverColor {

		/**
		 * @param {number} red Red channel.
		 * @param {number} green Green channel.
		 * @param {number} blue Blue channel.
		 */
		constructor( red, green, blue ) {

			this.set( red, green, blue );

		}

		/**
		 * @param {number} red Red channel.
		 * @param {number} green Green channel.
		 * @param {number} blue Blue channel.
		 * @return {void}
		 */
		set( red, green, blue ) {

			this.r = this.clamp( red );
			this.g = this.clamp( green );
			this.b = this.clamp( blue );

		}

		/**
		 * @param {number} value Channel value.
		 * @return {number} Clamped channel value.
		 */
		clamp( value ) {

			return Math.max( 0, Math.min( 255, value ) );

		}

		/**
		 * @param {number[]} matrix 3x3 matrix.
		 * @return {void}
		 */
		multiply( matrix ) {

			const red = this.clamp( ( this.r * matrix[ 0 ] ) + ( this.g * matrix[ 1 ] ) + ( this.b * matrix[ 2 ] ) );
			const green = this.clamp( ( this.r * matrix[ 3 ] ) + ( this.g * matrix[ 4 ] ) + ( this.b * matrix[ 5 ] ) );
			const blue = this.clamp( ( this.r * matrix[ 6 ] ) + ( this.g * matrix[ 7 ] ) + ( this.b * matrix[ 8 ] ) );
			this.set( red, green, blue );

		}

		/**
		 * @param {number} value Invert percentage in range 0..1.
		 * @return {void}
		 */
		invert( value ) {

			this.r = this.clamp( ( value + ( ( this.r / 255 ) * ( 1 - ( 2 * value ) ) ) ) * 255 );
			this.g = this.clamp( ( value + ( ( this.g / 255 ) * ( 1 - ( 2 * value ) ) ) ) * 255 );
			this.b = this.clamp( ( value + ( ( this.b / 255 ) * ( 1 - ( 2 * value ) ) ) ) * 255 );

		}

		/**
		 * @param {number} value Sepia percentage in range 0..1.
		 * @return {void}
		 */
		sepia( value ) {

			this.multiply( [
				0.393 + ( 0.607 * ( 1 - value ) ),
				0.769 - ( 0.769 * ( 1 - value ) ),
				0.189 - ( 0.189 * ( 1 - value ) ),
				0.349 - ( 0.349 * ( 1 - value ) ),
				0.686 + ( 0.314 * ( 1 - value ) ),
				0.168 - ( 0.168 * ( 1 - value ) ),
				0.272 - ( 0.272 * ( 1 - value ) ),
				0.534 - ( 0.534 * ( 1 - value ) ),
				0.131 + ( 0.869 * ( 1 - value ) ),
			] );

		}

		/**
		 * @param {number} value Saturate multiplier.
		 * @return {void}
		 */
		saturate( value ) {

			this.multiply( [
				0.213 + ( 0.787 * value ),
				0.715 - ( 0.715 * value ),
				0.072 - ( 0.072 * value ),
				0.213 - ( 0.213 * value ),
				0.715 + ( 0.285 * value ),
				0.072 - ( 0.072 * value ),
				0.213 - ( 0.213 * value ),
				0.715 - ( 0.715 * value ),
				0.072 + ( 0.928 * value ),
			] );

		}

		/**
		 * @param {number} angle Angle in degrees.
		 * @return {void}
		 */
		hueRotate( angle ) {

			const radians = ( angle / 180 ) * Math.PI;
			const sin = Math.sin( radians );
			const cos = Math.cos( radians );

			this.multiply( [
				0.213 + ( cos * 0.787 ) - ( sin * 0.213 ),
				0.715 - ( cos * 0.715 ) - ( sin * 0.715 ),
				0.072 - ( cos * 0.072 ) + ( sin * 0.928 ),
				0.213 - ( cos * 0.213 ) + ( sin * 0.143 ),
				0.715 + ( cos * 0.285 ) + ( sin * 0.14 ),
				0.072 - ( cos * 0.072 ) - ( sin * 0.283 ),
				0.213 - ( cos * 0.213 ) - ( sin * 0.787 ),
				0.715 - ( cos * 0.715 ) + ( sin * 0.715 ),
				0.072 + ( cos * 0.928 ) + ( sin * 0.072 ),
			] );

		}

		/**
		 * @param {number} value Brightness multiplier.
		 * @return {void}
		 */
		brightness( value ) {

			this.linear( value );

		}

		/**
		 * @param {number} value Contrast multiplier.
		 * @return {void}
		 */
		contrast( value ) {

			this.linear( value, ( -0.5 * value ) + 0.5 );

		}

		/**
		 * @param {number} slope Linear slope.
		 * @param {number} intercept Linear intercept.
		 * @return {void}
		 */
		linear( slope, intercept = 0 ) {

			this.r = this.clamp( ( this.r * slope ) + ( intercept * 255 ) );
			this.g = this.clamp( ( this.g * slope ) + ( intercept * 255 ) );
			this.b = this.clamp( ( this.b * slope ) + ( intercept * 255 ) );

		}

		/**
		 * @return {{h:number,s:number,l:number}} HSL channels.
		 */
		hsl() {

			const red = this.r / 255;
			const green = this.g / 255;
			const blue = this.b / 255;
			const max = Math.max( red, green, blue );
			const min = Math.min( red, green, blue );
			const lightness = ( max + min ) / 2;
			const delta = max - min;

			if ( delta === 0 ) {

				return { h: 0, s: 0, l: lightness * 100 };

			}

			const saturation = lightness > 0.5 ? delta / ( 2 - max - min ) : delta / ( max + min );
			let hue = 0;

			switch ( max ) {

			case red:
				hue = ( green - blue ) / delta + ( green < blue ? 6 : 0 );
				break;
			case green:
				hue = ( blue - red ) / delta + 2;
				break;
			default:
				hue = ( red - green ) / delta + 4;

			}

			return {
				h: hue * 60,
				s: saturation * 100,
				l: lightness * 100,
			};

		}

	}

	/**
	 * Calculate css filter values that approximate provided RGB color.
	 *
	 * @param {{r:number,g:number,b:number}} targetRgb Target rgb channels.
	 * @return {number[]} Filter value tuple.
	 */
	const solveCssFilterValues = ( targetRgb ) => {

		const targetColor = new SolverColor( targetRgb.r, targetRgb.g, targetRgb.b );
		const targetHsl = targetColor.hsl();
		const baseColor = new SolverColor( 0, 0, 0 );

		/**
		 * @param {number[]} values Filter values.
		 * @return {number} Loss value.
		 */
		const loss = ( values ) => {

			const sample = new SolverColor( baseColor.r, baseColor.g, baseColor.b );
			sample.invert( values[ 0 ] / 100 );
			sample.sepia( values[ 1 ] / 100 );
			sample.saturate( values[ 2 ] / 100 );
			sample.hueRotate( values[ 3 ] * 3.6 );
			sample.brightness( values[ 4 ] / 100 );
			sample.contrast( values[ 5 ] / 100 );

			const sampleHsl = sample.hsl();

			return Math.abs( sample.r - targetRgb.r ) +
				Math.abs( sample.g - targetRgb.g ) +
				Math.abs( sample.b - targetRgb.b ) +
				Math.abs( sampleHsl.h - targetHsl.h ) +
				Math.abs( sampleHsl.s - targetHsl.s ) +
				Math.abs( sampleHsl.l - targetHsl.l );

		};

		/**
		 * @param {number} value Candidate value.
		 * @param {number} index Filter index.
		 * @return {number} Bounded value.
		 */
		const fix = ( value, index ) => {

			let max = 100;
			if ( index === 2 ) {

				max = 7500;

			} else if ( index === 4 || index === 5 ) {

				max = 200;

			}

			if ( index === 3 ) {

				if ( value > max ) {

					return value % max;

				}

				return value < 0 ? ( max + ( value % max ) ) : value;

			}

			return Math.max( 0, Math.min( max, value ) );

		};

		/**
		 * @param {number} aBase A term.
		 * @param {number[]} aRates Rate vector.
		 * @param {number} cBase C term.
		 * @param {number[]} values Initial values.
		 * @param {number} iterations Iteration count.
		 * @return {{values:number[],loss:number}} Best candidate.
		 */
		const spsa = ( aBase, aRates, cBase, values, iterations ) => {

			const alpha = 1;
			const gamma = 1 / 6;
			let bestLoss = Number.POSITIVE_INFINITY;
			let bestValues = values.slice();
			const currentValues = values.slice();

			for ( let iteration = 0; iteration < iterations; iteration += 1 ) {

				const ck = cBase / Math.pow( iteration + 1, gamma );
				const deltas = [];
				const highValues = [];
				const lowValues = [];

				for ( let index = 0; index < currentValues.length; index += 1 ) {

					deltas.push( Math.random() > 0.5 ? 1 : -1 );
					highValues.push( currentValues[ index ] + ( ck * deltas[ index ] ) );
					lowValues.push( currentValues[ index ] - ( ck * deltas[ index ] ) );

				}

				const highLoss = loss( highValues );
				const lowLoss = loss( lowValues );
				const lossDiff = highLoss - lowLoss;

				for ( let index = 0; index < currentValues.length; index += 1 ) {

					const gradient = ( lossDiff / ( 2 * ck ) ) * deltas[ index ];
					const ak = aRates[ index ] / Math.pow( aBase + iteration + 1, alpha );
					currentValues[ index ] = fix( currentValues[ index ] - ( ak * gradient ), index );

				}

				const valueLoss = loss( currentValues );
				if ( valueLoss < bestLoss ) {

					bestLoss = valueLoss;
					bestValues = currentValues.slice();

				}

			}

			return { values: bestValues, loss: bestLoss };

		};

		const wideTrials = 3;
		let bestWide = { values: [ 50, 20, 3750, 50, 100, 100 ], loss: Number.POSITIVE_INFINITY };

		for ( let trial = 0; trial < wideTrials; trial += 1 ) {

			const result = spsa(
				5,
				[ 60, 180, 18000, 600, 1.2, 1.2 ],
				15,
				[ 50, 20, 3750, 50, 100, 100 ],
				1000,
			);

			if ( result.loss < bestWide.loss ) {

				bestWide = result;

			}

		}

		const narrowScale = bestWide.loss + 1;
		const narrow = spsa(
			bestWide.loss,
			[ 0.25 * narrowScale, 0.25 * narrowScale, narrowScale, 0.25 * narrowScale, 0.2 * narrowScale, 0.2 * narrowScale ],
			2,
			bestWide.values,
			500,
		);

		return narrow.values.map( ( value ) => Math.round( value ) );

	};

	/**
	 * Convert color value to css filter string for monochrome icon tinting.
	 *
	 * @param {string} color Color value.
	 * @return {string} CSS filter.
	 */
	const hexToCssFilter = ( color ) => {

		const targetRgb = resolveColorToRgb( color );
		const cacheKey = `${targetRgb.r},${targetRgb.g},${targetRgb.b}`;
		const cached = cssFilterCache.get( cacheKey );
		if ( cached ) {

			return cached;

		}

		const values = solveCssFilterValues( targetRgb );
		const computedFilter = `brightness(0) saturate(100%) invert(${values[ 0 ]}%) sepia(${values[ 1 ]}%) saturate(${values[ 2 ]}%) hue-rotate(${Math.round( values[ 3 ] * 3.6 )}deg) brightness(${values[ 4 ]}%) contrast(${values[ 5 ]}%)`;
		cssFilterCache.set( cacheKey, computedFilter );

		return computedFilter;

	};

	/**
	 * Build SVG path for a donut segment with optional rounded outer corners.
	 *
	 * @param {number} cx Circle center x.
	 * @param {number} cy Circle center y.
	 * @param {number} outerRadius Outer radius.
	 * @param {number} innerRadius Inner radius.
	 * @param {number} startAngle Segment start angle.
	 * @param {number} endAngle Segment end angle.
	 * @param {number} outerCornerRadius Rounded corner radius for outer edge.
	 * @return {string} SVG path data.
	 */
	const createArcPath = ( cx, cy, outerRadius, innerRadius, startAngle, endAngle, outerCornerRadius = 0 ) => {

		/**
		 * Convert polar coordinates into cartesian coordinates.
		 *
		 * @param {number} radius Circle radius.
		 * @param {number} angle Angle in degrees.
		 * @return {{x:number,y:number}} Point coordinates.
		 */
		const toPoint = ( radius, angle ) => {

			const radians = ( ( angle - 90 ) * Math.PI ) / 180;
			return {
				x: cx + ( radius * Math.cos( radians ) ),
				y: cy + ( radius * Math.sin( radians ) ),
			};

		};

		const segmentSweep = endAngle - startAngle;
		const maxByThickness = Math.max( 0, ( outerRadius - innerRadius ) - 1 );
		const maxByAngle = Math.max( 0, ( ( segmentSweep * Math.PI ) / 360 ) * outerRadius - 0.5 );
		const corner = Math.min( Math.max( 0, outerCornerRadius ), maxByThickness, maxByAngle );
		const cornerAngleOffset = corner > 0 ? ( corner / outerRadius ) * ( 180 / Math.PI ) : 0;

		const outerStartAngle = startAngle + cornerAngleOffset;
		const outerEndAngle = endAngle - cornerAngleOffset;

		if ( outerStartAngle >= outerEndAngle ) {

			const outerStart = toPoint( outerRadius, startAngle );
			const outerEnd = toPoint( outerRadius, endAngle );
			const innerEnd = toPoint( innerRadius, endAngle );
			const innerStart = toPoint( innerRadius, startAngle );
			const largeArcFlag = segmentSweep > 180 ? 1 : 0;

			return [
				`M ${outerStart.x} ${outerStart.y}`,
				`A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${outerEnd.x} ${outerEnd.y}`,
				`L ${innerEnd.x} ${innerEnd.y}`,
				`A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${innerStart.x} ${innerStart.y}`,
				'Z',
			].join( ' ' );

		}

		const cornerInset = Math.min( corner, maxByThickness );
		const outerStartCorner = toPoint( outerRadius, startAngle );
		const outerEndCorner = toPoint( outerRadius, endAngle );
		const outerStartArc = toPoint( outerRadius, outerStartAngle );
		const outerEndArc = toPoint( outerRadius, outerEndAngle );
		const outerStartInset = toPoint( outerRadius - cornerInset, startAngle );
		const outerEndInset = toPoint( outerRadius - cornerInset, endAngle );
		const innerStart = toPoint( innerRadius, startAngle );
		const innerEnd = toPoint( innerRadius, endAngle );

		const largeArcOuter = ( outerEndAngle - outerStartAngle ) > 180 ? 1 : 0;
		const largeArcInner = segmentSweep > 180 ? 1 : 0;

		return [
			`M ${outerStartArc.x} ${outerStartArc.y}`,
			`A ${outerRadius} ${outerRadius} 0 ${largeArcOuter} 1 ${outerEndArc.x} ${outerEndArc.y}`,
			`Q ${outerEndCorner.x} ${outerEndCorner.y} ${outerEndInset.x} ${outerEndInset.y}`,
			`L ${innerEnd.x} ${innerEnd.y}`,
			`A ${innerRadius} ${innerRadius} 0 ${largeArcInner} 0 ${innerStart.x} ${innerStart.y}`,
			`L ${outerStartInset.x} ${outerStartInset.y}`,
			`Q ${outerStartCorner.x} ${outerStartCorner.y} ${outerStartArc.x} ${outerStartArc.y}`,
			'Z',
		].join( ' ' );

	};

	/**
	 * Render pie ring SVG.
	 *
	 * @return {void}
	 */
	const renderRing = () => {

		const ringSize = ring.getBoundingClientRect().width;
		const holeSize = getCenterHoleSize();

		if ( ringSize <= 0 || holeSize <= 0 ) {

			return;

		}

		const center = ringSize / 2;
		const outerRadius = center;
		const innerRadius = holeSize / 2;
		const outerCornerRadius = Math.min( 22, ( outerRadius - innerRadius ) * 0.38 );
		let startAngle = 0;
		const paths = normalizedSegments.map( ( segment, index ) => {

			const endAngle = startAngle + ( segment.percentage / 100 ) * 360;
			const path = createArcPath( center, center, outerRadius, innerRadius, startAngle, endAngle, outerCornerRadius );
			startAngle = endAngle;
			return [
				`<g class="b-chart-info__segment${activeSegmentIndex === index ? ' is-active' : ''}" data-segment-index="${index}">`,
				`<path d="${path}" fill="${segment.color}" />`,
				`<path d="${path}" fill="none" stroke="rgba(0,0,0,0.16)" stroke-width="5" stroke-linejoin="round" />`,
				'</g>',
			].join( '' );

		} );

		ring.innerHTML = `
			<svg viewBox="0 0 ${ringSize} ${ringSize}" width="${ringSize}" height="${ringSize}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
				${paths.join( '' )}
			</svg>
		`;

	};

	/**
	 * Update active state across ring segments and hotspots.
	 *
	 * @param {?number} index Active segment index.
	 * @return {void}
	 */
	const setActiveSegment = ( index ) => {

		activeSegmentIndex = Number.isInteger( index ) ? index : null;

		Array.from( ring.querySelectorAll( '.b-chart-info__segment' ) ).forEach( ( segmentElement, segmentIndex ) => {

			segmentElement.classList.toggle( 'is-active', activeSegmentIndex === segmentIndex );

		} );

		Array.from( hotspotsContainer.querySelectorAll( '.b-chart-info__hotspot' ) ).forEach( ( hotspot, hotspotIndex ) => {

			hotspot.classList.toggle( 'is-active', hotspotIndex === activeSegmentIndex );

		} );

	};

	/**
	 * Attach accordion behavior in modal list.
	 *
	 * @param {HTMLElement} [rootAccordion] Accordion root element.
	 * @param {string} [segmentColor] Segment color used by dropdown indicators.
	 * @return {void}
	 */
	const applyAccordion = ( rootAccordion = accordion, segmentColor = '' ) => {

		const items = Array.from( rootAccordion.querySelectorAll( '.js-chart-info-dropdown-item' ) );
		const indicatorColor = normalizeColorToken( segmentColor );

		items.forEach( ( item ) => {

			const trigger = item.querySelector( '.js-chart-info-dropdown-trigger' );
			const content = item.querySelector( '.js-chart-info-dropdown-content' );

			if ( ! trigger || ! content ) {

				return;

			}

			const indicator = item.querySelector( '.b-chart-info-dropdown-item__indicator' );

			if ( indicatorColor && indicator ) {

				indicator.style.backgroundColor = indicatorColor;

			}

			/**
			 * Expand current accordion item.
			 *
			 * @return {void}
			 */
			const openItem = () => {

				item.classList.add( 'is-open' );
				content.getBoundingClientRect();
				content.style.maxHeight = `${content.scrollHeight + 2}px`;

			};

			/**
			 * Collapse current accordion item.
			 *
			 * @return {void}
			 */
			const closeItem = () => {

				item.classList.remove( 'is-open' );
				content.style.maxHeight = '0px';

			};

			closeItem();

			trigger.addEventListener( 'click', ( event ) => {

				event.preventDefault();
				if ( item.classList.contains( 'is-open' ) ) {

					closeItem();
					return;

				}

				items.forEach( ( otherItem ) => {

					const otherContent = otherItem.querySelector( '.js-chart-info-dropdown-content' );

					if ( ! otherContent ) {

						return;

					}

					otherItem.classList.remove( 'is-open' );
					otherContent.style.maxHeight = '0px';

				} );

				openItem();

			} );

		} );

	};

	/**
	 * Resolve modal coordinates relative to chart area.
	 *
	 * @param {number} pointX Click x coordinate.
	 * @param {number} pointY Click y coordinate.
	 * @return {{left:number,top:number,shouldOpenLeft:boolean}} Position object.
	 */
	const getModalPosition = ( pointX, pointY ) => {

		const containerRect = layout.getBoundingClientRect();
		const wheelRect = wheel.getBoundingClientRect();
		const modalRect = modal.getBoundingClientRect();
		const modalWidth = modalRect.width || 420;
		const modalHeight = modalRect.height || 320;
		const gap = 24;

		const distanceToLeftEdge = pointX - containerRect.left;
		const distanceToRightEdge = containerRect.right - pointX;
		const shouldOpenLeft = distanceToLeftEdge < distanceToRightEdge;

		let left = shouldOpenLeft
			? ( wheelRect.left - containerRect.left ) - modalWidth - gap
			: ( wheelRect.right - containerRect.left ) + gap;
		let top = pointY - containerRect.top - ( modalHeight / 2 );

		left = Math.max( 0, Math.min( left, containerRect.width - modalWidth ) );
		top = Math.max( 0, Math.min( top, containerRect.height - modalHeight ) );

		return { left, top, shouldOpenLeft };

	};

	/**
	 * Render and open modal for a selected segment.
	 *
	 * @param {number} index Segment index.
	 * @param {number} pointX Trigger point x coordinate.
	 * @param {number} pointY Trigger point y coordinate.
	 * @return {void}
	 */
	const renderModal = ( index, pointX, pointY ) => {

		const segment = normalizedSegments[ index ];

		if ( ! segment ) {

			return;

		}

		modal.hidden = true;
		modalTitle.textContent = segment.name;
		modalHeader.style.backgroundColor = hexToRgba( segment.color, 0.1 );
		modalIconWrap.style.backgroundColor = hexToRgba( segment.color, 0.12 );
		if ( segment.iconUrl ) {

			modalIcon.setAttribute( 'src', segment.iconUrl );
			modalIcon.setAttribute( 'alt', segment.iconAlt || segment.name );
			modalIcon.style.filter = hexToCssFilter( segment.color );
			modalIcon.hidden = false;
			modalIconWrap.hidden = false;

		} else {

			modalIcon.hidden = true;
			modalIconWrap.hidden = true;

		}

		if ( modalSummary ) {

			modalSummary.textContent = segment.modalDescription || '';
			modalSummary.hidden = ! segment.modalDescription;

		}
		accordion.innerHTML = segment.itemsMarkup;
		applyAccordion( accordion, segment.color );
		modal.hidden = false;
		modal.classList.remove( 'is-position-left', 'is-position-right' );

		const position = getModalPosition( pointX, pointY );
		modal.style.left = `${position.left}px`;
		modal.style.top = `${position.top}px`;
		modal.classList.add( position.shouldOpenLeft ? 'is-position-left' : 'is-position-right' );

		setActiveSegment( index );

	};

	/**
	 * Hide desktop modal and clear active segment state.
	 *
	 * @return {void}
	 */
	const closeModal = () => {

		modal.hidden = true;
		modal.classList.remove( 'is-position-left', 'is-position-right' );
		setActiveSegment( null );

	};

	/**
	 * Build labels around the chart.
	 *
	 * @return {void}
	 */
	const buildHotspots = () => {

		const wheelSize = wheel.getBoundingClientRect().width;
		const holeSize = getCenterHoleSize();

		if ( wheelSize <= 0 || holeSize <= 0 ) {

			return;

		}

		hotspotsContainer.innerHTML = '';
		const center = wheelSize / 2;
		const outerRadius = center;
		const innerRadius = holeSize / 2;
		const hotspotRadius = innerRadius + ( ( outerRadius - innerRadius ) / 2 );
		let angleStart = 0;

		/**
		 * Convert polar coordinates into cartesian coordinates.
		 *
		 * @param {number} radius Circle radius.
		 * @param {number} angle Angle in degrees.
		 * @return {{x:number,y:number}} Point coordinates.
		 */
		const toPoint = ( radius, angle ) => {

			const radians = ( ( angle - 90 ) * Math.PI ) / 180;
			return {
				x: center + ( radius * Math.cos( radians ) ),
				y: center + ( radius * Math.sin( radians ) ),
			};

		};

		normalizedSegments.forEach( ( segment, index ) => {

			const segmentAngle = ( segment.percentage / 100 ) * 360;
			const middleAngle = angleStart + ( segmentAngle / 2 );
			const { x: left, y: top } = toPoint( hotspotRadius, middleAngle );

			const hotspot = document.createElement( 'button' );
			hotspot.type = 'button';
			hotspot.className = 'b-chart-info__hotspot';
			hotspot.style.left = `${left}px`;
			hotspot.style.top = `${top}px`;
			if ( segment.iconUrl ) {

				const iconWrap = document.createElement( 'span' );
				iconWrap.className = 'b-chart-info__hotspot-icon-wrap';
				const icon = document.createElement( 'img' );
				icon.src = segment.iconUrl;
				icon.alt = segment.iconAlt || segment.name;
				icon.loading = 'lazy';
				iconWrap.appendChild( icon );
				hotspot.appendChild( iconWrap );

			}
			const title = document.createElement( 'span' );
			title.textContent = segment.name;
			hotspot.appendChild( title );
			hotspot.addEventListener( 'click', ( event ) => {

				event.preventDefault();

				if ( isMobileLayout() ) {

					const targetModal = mobileModalsContainer?.querySelector( `[data-segment-index="${index}"]` );

					if ( targetModal ) {

						targetModal.scrollIntoView( { behavior: 'smooth', block: 'start' } );

					}

					return;

				}

				const wheelRect = wheel.getBoundingClientRect();
				renderModal( index, wheelRect.left + left, wheelRect.top + top );

			} );
			hotspot.addEventListener( 'mouseenter', () => {

				if ( isMobileLayout() ) {

					return;

				}

				const wheelRect = wheel.getBoundingClientRect();
				renderModal( index, wheelRect.left + left, wheelRect.top + top );

			} );
			hotspotsContainer.appendChild( hotspot );

			angleStart += segmentAngle;

		} );

	};

	/**
	 * Render summary cards under chart.
	 *
	 * @return {void}
	 */
	const buildSummaryCards = () => {

		if ( ! summaryContainer ) {

			return;

		}

		summaryContainer.innerHTML = '';
		normalizedSegments.forEach( ( segment ) => {

			const card = document.createElement( 'article' );
			card.className = 'b-chart-info__summary-item';

			const titleWrap = document.createElement( 'div' );
			titleWrap.className = 'b-chart-info__summary-head';

			if ( segment.iconUrl ) {

				const iconWrap = document.createElement( 'span' );
				iconWrap.className = 'b-chart-info__summary-icon-wrap';
				iconWrap.style.backgroundColor = hexToRgba( segment.color, 0.12 );

				const icon = document.createElement( 'img' );
				icon.className = 'b-chart-info__summary-icon';
				icon.src = segment.iconUrl;
				icon.alt = segment.iconAlt || segment.name;
				icon.loading = 'lazy';
				icon.style.filter = hexToCssFilter( segment.color );

				iconWrap.appendChild( icon );
				titleWrap.appendChild( iconWrap );

			}

			const title = document.createElement( 'h3' );
			title.className = 'b-chart-info__summary-title';
			title.textContent = segment.name;
			titleWrap.appendChild( title );
			card.appendChild( titleWrap );

			if ( segment.summary ) {

				const text = document.createElement( 'p' );
				text.className = 'b-chart-info__summary-text';
				text.textContent = segment.summary;
				card.appendChild( text );

			}

			summaryContainer.appendChild( card );

		} );

	};

	/**
	 * Build static modal cards under chart on mobile.
	 *
	 * @return {void}
	 */
	const buildMobileModals = () => {

		if ( ! mobileModalsContainer ) {

			mobileModalsContainer = document.createElement( 'div' );
			mobileModalsContainer.className = 'b-chart-info__mobile-modals js-chart-info-mobile-modals';
			wheelColumn.appendChild( mobileModalsContainer );

		}

		mobileModalsContainer.innerHTML = '';

		normalizedSegments.forEach( ( segment, index ) => {

			const modalCard = document.createElement( 'article' );
			modalCard.className = 'b-chart-info__modal b-chart-info__modal--mobile';
			modalCard.dataset.segmentIndex = String( index );

			const header = document.createElement( 'div' );
			header.className = 'b-chart-info__modal-header';
			header.style.backgroundColor = hexToRgba( segment.color, 0.1 );

			const headerMain = document.createElement( 'div' );
			headerMain.className = 'b-chart-info__modal-main';

			if ( segment.iconUrl ) {

				const iconWrap = document.createElement( 'span' );
				iconWrap.className = 'b-chart-info__modal-icon-wrap';
				iconWrap.style.backgroundColor = hexToRgba( segment.color, 0.12 );

				const icon = document.createElement( 'img' );
				icon.className = 'b-chart-info__modal-icon';
				icon.src = segment.iconUrl;
				icon.alt = segment.iconAlt || segment.name;
				icon.loading = 'lazy';
				icon.style.filter = hexToCssFilter( segment.color );

				iconWrap.appendChild( icon );
				headerMain.appendChild( iconWrap );

			}

			const titleWrap = document.createElement( 'span' );
			titleWrap.className = 'b-chart-info__modal-title-wrap';

			const title = document.createElement( 'span' );
			title.className = 'b-chart-info__modal-title';
			title.textContent = segment.name;
			titleWrap.appendChild( title );

			if ( segment.modalDescription ) {

				const summaryText = document.createElement( 'span' );
				summaryText.className = 'b-chart-info__modal-description';
				summaryText.textContent = segment.modalDescription;
				titleWrap.appendChild( summaryText );

			}

			headerMain.appendChild( titleWrap );
			header.appendChild( headerMain );
			modalCard.appendChild( header );

			const items = document.createElement( 'ul' );
			items.className = 'b-chart-info__accordion';
			items.innerHTML = segment.itemsMarkup;
			modalCard.appendChild( items );
			mobileModalsContainer.appendChild( modalCard );

		} );

		mobileModalsContainer.hidden = ! isMobileLayout();

		if ( ! isMobileLayout() ) {

			return;

		}

		mobileModalsContainer.querySelectorAll( '.b-chart-info__accordion' ).forEach( ( mobileAccordion ) => {

			const modalCard = mobileAccordion.closest( '.b-chart-info__modal--mobile' );
			const segmentIndex = Number.parseInt( modalCard?.dataset.segmentIndex || '', 10 );
			const segmentColor = Number.isInteger( segmentIndex ) ? normalizedSegments[ segmentIndex ]?.color || '' : '';
			applyAccordion( mobileAccordion, segmentColor );

		} );

	};

	renderRing();
	buildHotspots();
	buildSummaryCards();
	buildMobileModals();

	/**
	 * Resolve segment index from pointer position.
	 *
	 * @param {MouseEvent} event Pointer event.
	 * @return {?number} Segment index or null outside ring.
	 */
	const getSegmentIndexFromPointer = ( event ) => {

		const wheelRect = wheel.getBoundingClientRect();
		const centerX = wheelRect.left + ( wheelRect.width / 2 );
		const centerY = wheelRect.top + ( wheelRect.height / 2 );
		const pointerX = event.clientX;
		const pointerY = event.clientY;
		const deltaX = pointerX - centerX;
		const deltaY = pointerY - centerY;
		const distance = Math.sqrt( ( deltaX ** 2 ) + ( deltaY ** 2 ) );
		const outerRadius = wheelRect.width / 2;
		const innerRadius = getCenterHoleSize() / 2;

		if ( distance > outerRadius || distance < innerRadius ) {

			return null;

		}

		let angle = ( Math.atan2( deltaY, deltaX ) * 180 ) / Math.PI;
		angle = ( angle + 90 + 360 ) % 360;
		const anglePercent = ( angle / 360 ) * 100;

		let rangeEnd = 0;
		for ( let i = 0; i < normalizedSegments.length; i += 1 ) {

			rangeEnd += normalizedSegments[ i ].percentage;
			if ( anglePercent <= rangeEnd ) {

				return i;

			}

		}

		return normalizedSegments.length - 1;

	};

	wheel.addEventListener( 'mousemove', ( event ) => {

		if ( isMobileLayout() ) {

			return;

		}

		const segmentIndex = getSegmentIndexFromPointer( event );
		if ( segmentIndex === null ) {

			return;

		}

		if ( activeSegmentIndex === segmentIndex && ! modal.hidden ) {

			return;

		}

		renderModal( segmentIndex, event.clientX, event.clientY );

	} );

	closeButton.addEventListener( 'click', () => {

		closeModal();

	} );

	/**
	 * Re-render ring and hotspots after viewport resize.
	 *
	 * @return {void}
	 */
	const handleResize = () => {

		renderRing();
		buildHotspots();
		buildMobileModals();

		if ( isMobileLayout() ) {

			closeModal();

		}

	};

	window.addEventListener( 'resize', handleResize );

} );
